import { ReactComponent as Tag } from '@assets/icons/tag.svg';
import { useShowSvcPrice } from 'context/ShowSvcPriceContext';
import Image from 'next/image';

import { Flex, Grid, GridItem, Stack, Text, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

import { ProductItem as ProductItemType } from 'types';

import { Divider } from 'ui';

interface ProductItemProps {
  item: ProductItemType;
}

const ProductItem = ({ item }: ProductItemProps) => {
  const { name, brand_name, price, pr_code, qty } = item;
  const showSvcPrice = useShowSvcPrice();

  const {
    colors: {
      palette: {
        booking: {
          stepSuccess: {
            productList: { productItem }
          }
        }
      }
    }
  } = useTheme();

  // TODO: fill be needed in future
  // const hasClientDiscount = base_price > 0 && base_price > price;

  return (
    <Grid
      position='relative'
      templateColumns='repeat(12, 1fr)'
      templateRows={{
        base: 'repeat(3, auto)',
        lg: 'repeat(1, 1fr)'
      }}
      px={{ base: 15, md: '30px' }}
      py={{ base: '15px', md: '23px' }}
      gap={{ base: '10px', md: '20px' }}
      alignItems='center'
    >
      <GridItem colSpan={{ base: 7, lg: 6 }} gridRowStart={1}>
        <Text
          color={productItem.serviceNameColor}
          fontSize={{ base: '20px', md: '23px', xl: '25px' }}
          mt={{ base: '-3px', lg: 0 }}
        >
          {name}
        </Text>
      </GridItem>
      <GridItem colSpan={{ base: 7, lg: 3 }} rowSpan={{ base: 2, lg: 1 }}>
        <Flex alignItems='center' gap='10px'>
          <Flex
            alignItems='center'
            justifyContent={item?.primary_img_x2_url ? 'start' : 'center'}
            my='auto'
            position='relative'
            w={{ base: '35px', sm: '75px' }}
            h={{ base: '35px', sm: '75px' }}
            bg={
              item?.primary_img_x2_url
                ? productItem.imageBg
                : productItem.emptyImageBg
            }
            borderRadius='50%'
            overflow='hidden'
            sx={{
              '& > svg': {
                width: { base: '20px', sm: '35px' },
                height: { base: '20px', sm: '35px' }
              }
            }}
          >
            {item?.primary_img_x2_url ? (
              <Image
                src={item.primary_img_x2_url}
                alt='product'
                style={{ objectFit: 'contain', borderRadius: '5px' }}
                fill
                sizes='200px'
                quality={100}
              />
            ) : (
              <Tag fill={productItem.defaultIconColor} width={35} height={35} />
            )}
          </Flex>

          <Stack gap='6px' justifyContent='center' height='100%'>
            {brand_name && (
              <Text
                textTransform='uppercase'
                color={productItem.providerDescriptionColor}
                fontSize={{ base: '10px', md: '12px' }}
              >
                {brand_name}
              </Text>
            )}

            {pr_code && (
              <Text
                color={productItem.providerDescriptionColor}
                fontSize={{ base: '10px', md: '12px' }}
              >
                {pr_code}
              </Text>
            )}
          </Stack>
        </Flex>
      </GridItem>
      <GridItem
        colSpan={{ base: 5, lg: 3 }}
        rowSpan={{ base: 3, lg: 1 }}
        gridRowStart={1}
      >
        <Flex justifyContent='space-between' alignItems='center'>
          <Text
            w='50%'
            color={productItem.qtyColor}
            p={0}
            border={0}
            fontSize={{
              base: '24px',
              lg: '38px'
            }}
            pointerEvents='none'
            textAlign='center'
          >
            {qty}
          </Text>

          <Stack alignItems='flex-end' gap='0' ml='20px'>
            {showSvcPrice && (
              <Flex alignItems='center' gap={{ base: '22px', md: '18px' }}>
                <Text
                  color={productItem.priceColor}
                  fontSize={{ base: '20px', md: '25px' }}
                >
                  {formatCurrency(price)}
                </Text>
              </Flex>
            )}

            <Stack gap='8px' w='100%' alignItems='flex-end'>
              <Text
                color={productItem.memberSaveColor}
                fontSize={{ base: '13px', md: '15px' }}
                w='100%'
                textAlign='end'
                whiteSpace={{ base: 'normal', md: 'nowrap' }}
              >
                Each
              </Text>
            </Stack>
          </Stack>
        </Flex>
      </GridItem>

      <Divider
        position='absolute'
        width='100%'
        border='none'
        bottom='-1px'
        left='0'
        h='1px'
        bg={productItem.dividerColor}
      />
    </Grid>
  );
};

export default ProductItem;
